
import { MODULE } from "@/config/modules";
import { AuthService } from "@/services/auth-service";
import Vue from "vue";
import { IBreadCrumb } from "winfakt-vue-components";
import AppMissingModule from "@/components/common/MissingModule.vue";
import { JobService } from "@/services/job-service";
import {BackupService} from "@/services/backup-service";
import AppRestoreBackupModal from "@/components/settings-default/RestoreBackupModal.vue";
import AppPreviousBackups from "@/components/settings-default/PreviousBackups.vue";
import AppCreatingBackupModal from "@/components/settings-default/CreatingBackupModal.vue";
import { ModuleOnlineBackupFrequency } from "@/models/dossier/module-online-backup";

export default Vue.extend({
	data(){
		return {
			jobs: JobService.getJobs(),
			restoreBackupModal: false,
			canCreateBackup: false,
			creatingBackupModal: false,
			automaticBackupValue: ModuleOnlineBackupFrequency.MANUAL,
			isRestoringBackup: false
		};
	},
	computed: {
		path(): IBreadCrumb[] {
			return [
				{
					to: "/settings",
					value: this.$ct("general"),
				},
				{
					value: this.$ct("backup"),
				},
			] as IBreadCrumb[];
		},
		moduleId():number {
			return MODULE.ONLINE_BACKUP;
		},
		hasModule():boolean {
			return AuthService.hasModule(MODULE.ONLINE_BACKUP);
		},
		isCreatingBackup():boolean {
			return this.jobs.find(j=>j.Name == "create-backup") != null;
		},
		isRunningBackupTask():boolean {
			return this.isCreatingBackup || this.isRestoringBackup;
		},
		automaticBackupsEnabled():boolean {
			return this.automaticBackupValue != ModuleOnlineBackupFrequency.MANUAL;
		}
	},
	methods: {
		async createBackup(){
			this.creatingBackupModal = true;
			try{
				await BackupService.createBackup();
			}catch(err){
				this.creatingBackupModal = false;
			}
		},
		restoreBackup(){
			this.restoreBackupModal = true;
		},
		async setAutomaticBackupFrequency(freq:ModuleOnlineBackupFrequency){
			let prevValue = this.automaticBackupValue;
			this.automaticBackupValue = freq;
			try{
				this.automaticBackupValue = await BackupService.setAutoBackupSetting(freq);
			}catch(err){
				this.automaticBackupValue = prevValue;
			}
		},
		onRestoreBackupStart(){
			this.isRestoringBackup = true;
		},
		onRestoreBackupStop(){
			this.isRestoringBackup = false;
			JobService.fetchJobs();
		},
		async onBackupCreated(){
			this.canCreateBackup = await BackupService.canCreateBackup();
		},
		toggleAutomaticBackups(value:boolean){
			if (value) {
				this.setAutomaticBackupFrequency(ModuleOnlineBackupFrequency.DAILY);
			}else{
				this.setAutomaticBackupFrequency(ModuleOnlineBackupFrequency.MANUAL);
			}
		}
	},
	async created(){
		if (!this.hasModule) return;
		this.canCreateBackup = await BackupService.canCreateBackup();
		this.automaticBackupValue = await BackupService.getAutoBackupSetting();
		JobService.on("job-started/restore-backup_0", this.onRestoreBackupStart);
		JobService.on("job-stopped/restore-backup_0", this.onRestoreBackupStop);
		JobService.on("job-stopped/create-backup_0", this.onBackupCreated);
		this.isRestoringBackup = this.jobs.find(j=>j.Name == "restore-backup") != null;
	},
	async destroyed(){
		JobService.off("job-started/restore-backup_0", this.onRestoreBackupStart);
		JobService.off("job-stopped/restore-backup_0", this.onRestoreBackupStop);
		JobService.off("job-stopped/create-backup_0", this.onBackupCreated);
	},
	components: {
		AppMissingModule,
		AppRestoreBackupModal,
		AppPreviousBackups,
		AppCreatingBackupModal,
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	},
});
